import DefaultRenderer from './default';
import gallerySlider from '../../components/gallery-slider';

class singleMediaCenter extends DefaultRenderer {
	onEnter() {
		super.onEnter();
		let mainScroll = this.mainController.getScroll();

		let mediacenterGallery = document.getElementById('mediacenter-gallery');

		if (mediacenterGallery) {
			let navigationButtons = [
				document.getElementsByClassName('swiper-button-prev')[0],
				document.getElementsByClassName('swiper-button-next')[0],
			];

			gallerySlider('#mediacenter-gallery', navigationButtons, mainScroll);
		}
	}

	onLeave() {
		super.onLeave();
	}

	onEnterCompleted() {
		super.onEnterCompleted();
	}
}

export default singleMediaCenter;



// WEBPACK FOOTER //
// ./scripts/highway/renderers/singleSodeciaMediacenter.js